import React, { createContext, useContext, useState } from "react";
import { findUserByCredentials, USERS } from "./users";

const GATE_KEY = "ect-gate-user-v2";
// Legacy key from v1 (single hardcoded admin) — we ignore it; users must re-login.
const LEGACY_KEY = "ect-gate-auth-v1";

const GateContext = createContext({ authed: false, user: null, signIn: () => false, signOut: () => {} });

function loadStoredUser() {
  if (typeof window === "undefined") return null;
  // Migrate-clear legacy auth on first load
  if (localStorage.getItem(LEGACY_KEY)) localStorage.removeItem(LEGACY_KEY);
  const raw = localStorage.getItem(GATE_KEY);
  if (!raw) return null;
  try {
    const stored = JSON.parse(raw);
    // Re-hydrate from canonical roster so any roster updates win over stale storage
    const fresh = USERS.find(u => u.employeeId === stored.employeeId);
    return fresh || null;
  } catch {
    return null;
  }
}

export function GateProvider({ children }) {
  const [user, setUser] = useState(() => loadStoredUser());

  function signIn(employeeId, passcode) {
    const u = findUserByCredentials(employeeId, passcode);
    if (!u) return { ok: false, error: "Invalid Employee ID or passcode." };
    localStorage.setItem(GATE_KEY, JSON.stringify({ employeeId: u.employeeId }));
    setUser(u);
    return { ok: true, user: u };
  }
  function signOut() {
    localStorage.removeItem(GATE_KEY);
    setUser(null);
  }

  return (
    <GateContext.Provider value={{ authed: !!user, user, signIn, signOut }}>
      {children}
    </GateContext.Provider>
  );
}

export const useGate = () => useContext(GateContext);
